module.exports = __webpack_public_path__ + "img/help.4115af5e.svg";